import { apiDownloadFile } from 'modules/actions';
import ApiFetch from 'utils/apiFetch';
import { preparePath } from 'utils/preparePath';

const InvestmentAssetsInstance = ApiFetch();

export const URLS = {
  INVESTMENT_ASSETS: 'investment-assets',
  INVESTMENT_ASSET: 'investment-assets/:id',
  INVESTMENT_ASSET_VERIFY: 'investment-assets/verify',
  INVESTMENT_ASSETS_MASSIVE: 'investment-assets/massive',
  INVESTMENT_ASSETS_MASSIVE_TEMPLATE: 'investment-assets/massive/template',

  INVESTOR_ASSETS: 'investor-assets',
  INVESTOR_ASSET: 'investor-assets/:id',
  INVESTOR_ASSET_OPERATIONS: 'investor-assets/:id/organizations/:organization/operations',
  INVESTOR_ASSET_OPERATION: 'investor-assets/:id/organizations/:organization/operations/:opId',
  INVESTOR_ASSET_SYNCHRONIZE: 'investor-assets/:id/organizations/:organization/sync',
  INVESTOR_ORGANIZATIONS: 'investor-assets/organizations',
  INVESTOR_ORGANIZATION: 'investor-assets/organizations/:id',
  INVESTOR_ORGANIZATIONS_ACTIVATE: 'investor-assets/organizations/activate',
};

export async function getInvestorOrganizations(page, size, search, filters, sort) {
  const path = preparePath(URLS.INVESTOR_ORGANIZATIONS, {}, {
    page, size, search, filters, sort,
  });
  return InvestmentAssetsInstance.get(path);
}

export async function createInvestorOrganization(data) {
  const path = preparePath(URLS.INVESTOR_ORGANIZATIONS);
  return InvestmentAssetsInstance.post(path, data);
}

export async function updateInvestorOrganization(id, data) {
  const path = preparePath(URLS.INVESTOR_ORGANIZATION, { id });
  return InvestmentAssetsInstance.put(path, data);
}

export async function deleteInvestorOrganization(id) {
  const path = preparePath(URLS.INVESTOR_ORGANIZATION, { id });
  return InvestmentAssetsInstance.delete(path);
}

export async function activateInvestorOrganizations(sessionId) {
  const path = preparePath(URLS.INVESTOR_ORGANIZATIONS_ACTIVATE, {}, { sessionId });
  return InvestmentAssetsInstance.post(path);
}

// Investor Assets
export async function getInvestorAssets(params = {}) {
  const path = preparePath(URLS.INVESTOR_ASSETS, {}, params);
  return InvestmentAssetsInstance.get(path);
}

export async function getInvestorAsset(id, params = {}) {
  const path = preparePath(URLS.INVESTOR_ASSET, { id }, params);
  return InvestmentAssetsInstance.get(path);
}

export async function getInvestorAssetOperations(id, organization, params = {}) {
  const path = preparePath(URLS.INVESTOR_ASSET_OPERATIONS, { id, organization }, params);
  return InvestmentAssetsInstance.get(path);
}

export async function synchronizeInvestorAsset(id, organization, data = {}) {
  const path = preparePath(URLS.INVESTOR_ASSET_SYNCHRONIZE, { id, organization });
  return InvestmentAssetsInstance.post(path, data);
}

export async function deleteInvestorAsset(id, params = {}) {
  const path = preparePath(URLS.INVESTOR_ASSET, { id }, params);
  return InvestmentAssetsInstance.delete(path);
}

// Investment Assets
export async function getInvestmentAssets(params = {}) {
  const path = preparePath(URLS.INVESTMENT_ASSETS, {}, params);
  return InvestmentAssetsInstance.get(path);
}

export async function createInvestmentAsset(data) {
  return InvestmentAssetsInstance.post(URLS.INVESTMENT_ASSETS, data);
}

export async function updateInvestmentAsset(id, data) {
  const path = preparePath(URLS.INVESTMENT_ASSET, { id });
  return InvestmentAssetsInstance.put(path, data);
}

export async function getInvestmentAsset(id, params = {}) {
  const path = preparePath(URLS.INVESTMENT_ASSET, { id }, params);
  return InvestmentAssetsInstance.get(path);
}

export async function deleteInvestmentAsset(id) {
  const path = preparePath(URLS.INVESTMENT_ASSET, { id });
  return InvestmentAssetsInstance.delete(path);
}

export async function verifyInvestmentAsset(auxIds, verified = 'non') {
  const path = URLS.INVESTMENT_ASSET_VERIFY;
  const ids = typeof auxIds === 'string' ? [auxIds] : auxIds;
  return InvestmentAssetsInstance.post(path, { ids, verified });
}

export async function createInvestmentOperation(id, organization, data) {
  const path = preparePath(URLS.INVESTOR_ASSET_OPERATIONS, { id, organization });
  return InvestmentAssetsInstance.post(path, data);
}

export async function deleteInvestmentOperation(id, organization, opId) {
  const path = preparePath(URLS.INVESTOR_ASSET_OPERATION, { id, organization, opId });
  return InvestmentAssetsInstance.delete(path);
}

export async function uploadInvestmentAssetsMassive(file, type) {
  const path = preparePath(URLS.INVESTMENT_ASSETS_MASSIVE);
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  return InvestmentAssetsInstance.post(path, formData);
}

export async function getInvestmentAssetsMassiveTemplate(type) {
  const filename = `${type}_template.xlsx`;
  return apiDownloadFile(`/api/v1/${URLS.INVESTMENT_ASSETS_MASSIVE_TEMPLATE}?type=${type}`, filename);
}
